(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["female-root-cause-section"] && !Shopify.designMode) return;
  try {
    
   window.addEventListener("DOMContentLoaded", function () {
    const $slider = $('.global-root-cause_slider');
    // const $progressBar = $('.global-root-cause_progress');
    // const $progressBarLabel = $( '.slider__label' );

    //  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    //   var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
      
    //   $progressBar
    //     .css('background-size', calc + '% 100%')
    //     .attr('aria-valuenow', calc );
      
    //   $progressBarLabel.text( calc + '% completed' );
    // });

    // $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
    //   if (window.innerWidth < 769) {
    //     $('.global-root-cause_card').removeClass('active');
    //     $('.global-root-cause_slide.slick-current .global-root-cause_card').addClass('active');
    //   }
    // });

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow: '<button class="slick-prev"><</button>',
      nextArrow: '<button class="slick-next">></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: true,
            arrows: false
          }
        }
      ]
    });

    // Blur last visible card on desktop
    // function applyBlurEffect() {
    //   // Remove previous blur class
    //   $('.global-root-cause_slide').removeClass('root-cause-blur-image');
    
    //   if (window.innerWidth >= 769) {
    //     // Get all currently visible slides
    //     let activeSlides = $('.global-root-cause_slide.slick-active');
    //     // Always target the last visible slide
    //     let lastVisibleSlide = activeSlides.last();
    //     lastVisibleSlide.addClass('root-cause-blur-image');
    //   }
    // }

    // applyBlurEffect();
    // $(window).on('resize', function () {
    //   setTimeout(applyBlurEffect, 300); 
    // });

    // $slider.on('afterChange', function () {
    //   applyBlurEffect();
    // });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-our-essential"] && !Shopify.designMode) return;
  try {
    
   window.addEventListener("DOMContentLoaded", function () {
    const $slider = $('.global-our-essential_slider');
    const $progressBar = $('.global-our-essential-product_progress');
    const $progressBarLabel = $( '.slider__label' );

     $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
      var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
      
      $progressBar
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc );
      
      $progressBarLabel.text( calc + '% completed' );
    });

    // $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
    //   if (window.innerWidth < 769) {
    //     $('.global-our-essential_card').removeClass('active');
    //     $('.global-our-essential_slide.slick-current .global-our-essential_card').addClass('active');
    //   }
    // });

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow: '<button class="slick-prev"><</button>',
      nextArrow: '<button class="slick-next">></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: true,
            arrows: false
          }
        }
      ]
    });

    // Blur last visible card on desktop
    // function applyBlurEffect() {
    //   // Remove previous blur class
    //   $('.global-our-essential-card-image_wrapper').removeClass('blur-image');
    
    //   if (window.innerWidth >= 769) {
    //     let activeSlides = $('.global-our-essential_slide.slick-active');
    //     let thirdSlide = activeSlides.eq(2); // 0-based index
    //     thirdSlide.find('.global-our-essential-card-image_wrapper').addClass('blur-image');
    //   }
    // }

    // applyBlurEffect();
    // $(window).on('resize', function () {
    //   setTimeout(applyBlurEffect, 300);
    // });

    // $slider.on('afterChange', function () {
    //   applyBlurEffect();
    // });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-root-cause-section"] && !Shopify.designMode) return;
  try {
    
   window.addEventListener("DOMContentLoaded", function () {
    const $slider = $('.global-root-cause_slider');
    // const $progressBar = $('.global-root-cause_progress');
    // const $progressBarLabel = $( '.slider__label' );

    //  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    //   var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
      
    //   $progressBar
    //     .css('background-size', calc + '% 100%')
    //     .attr('aria-valuenow', calc );
      
    //   $progressBarLabel.text( calc + '% completed' );
    // });

    // $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
    //   if (window.innerWidth < 769) {
    //     $('.global-root-cause_card').removeClass('active');
    //     $('.global-root-cause_slide.slick-current .global-root-cause_card').addClass('active');
    //   }
    // });

    $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      prevArrow: '<button class="slick-prev"><</button>',
      nextArrow: '<button class="slick-next">></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: true,
            arrows: false
          }
        }
      ]
    });

    // Blur last visible card on desktop
    // function applyBlurEffect() {
    //   // Remove previous blur class
    //   $('.global-root-cause_slide').removeClass('root-cause-blur-image');
    
    //   if (window.innerWidth >= 769) {
    //     // Get all currently visible slides
    //     let activeSlides = $('.global-root-cause_slide.slick-active');
    //     // Always target the last visible slide
    //     let lastVisibleSlide = activeSlides.last();
    //     lastVisibleSlide.addClass('root-cause-blur-image');
    //   }
    // }

    // applyBlurEffect();
    // $(window).on('resize', function () {
    //   setTimeout(applyBlurEffect, 300); 
    // });

    // $slider.on('afterChange', function () {
    //   applyBlurEffect();
    // });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
               $(document).ready(function(){
    setTimeout(function(){
      $('.product-recommendations .grid').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              dots: false
            }
          }
        ]
      });
    },10);
  });
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uae-doctor-prescribed"] && !Shopify.designMode) return;
  try {
    
  if(jQuery('.animate').length > 0 ){
    jQuery('.animate > span:first-child').addClass('active');
    var select_el = jQuery('.animate > span');
    setInterval(function(){
      if(select_el.hasClass('active')){
        jQuery('.animate > span.active').removeClass('active').next().addClass('active');
      }
      if(jQuery('.animate > span:last-child').hasClass('active')){
        jQuery('.animate > span:last-child').removeClass('active');
        jQuery('.animate > span:first-child').addClass('active');
      }
    }, 1000);
  }

  } catch(e) { console.error(e); }
})();
})();
